
export const reportTypes = [
  { value: 'finance', label: 'Finance Reports' },
  { value: 'gst', label: 'GST Reports' },
  { value: 'vendor', label: 'Vendor Reports' },
  { value: 'compliance', label: 'Compliance Reports' },
  { value: 'audit', label: 'Audit Reports' },
  { value: 'sales', label: 'Sales Reports' },
  { value: 'inventory', label: 'Inventory Reports' }
];

export const frequencyOptions = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' }
];

export function generateSchedulePayload(
  type: string, 
  recipients: string[], 
  frequency: 'daily' | 'weekly' | 'monthly' | 'quarterly', 
  filters: any
) {
  const now = new Date();
  let nextRun: string;
  
  switch (frequency) {
    case 'daily':
      nextRun = new Date(now.getTime() + 24 * 60 * 60 * 1000).toISOString();
      break;
    case 'weekly':
      nextRun = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();
      break;
    case 'monthly':
      const nextMonth = new Date(now);
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      nextRun = nextMonth.toISOString();
      break;
    case 'quarterly':
      const nextQuarter = new Date(now);
      nextQuarter.setMonth(nextQuarter.getMonth() + 3);
      nextRun = nextQuarter.toISOString();
      break;
    default:
      nextRun = new Date(now.getTime() + 24 * 60 * 60 * 1000).toISOString();
  }
  
  return {
    type,
    recipients: recipients.filter(email => email.trim() !== ''),
    frequency,
    filters,
    nextRun,
    enabled: true,
    createdAt: now.toISOString()
  };
}

export function calculateNextRun(frequency: string, lastRun?: string): string {
  const base = lastRun ? new Date(lastRun) : new Date();
  
  switch (frequency) {
    case 'daily':
      return new Date(base.getTime() + 24 * 60 * 60 * 1000).toISOString();
    case 'weekly':
      return new Date(base.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();
    case 'monthly':
      const nextMonth = new Date(base);
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      return nextMonth.toISOString();
    case 'quarterly':
      const nextQuarter = new Date(base);
      nextQuarter.setMonth(nextQuarter.getMonth() + 3);
      return nextQuarter.toISOString();
    default:
      return new Date(base.getTime() + 24 * 60 * 60 * 1000).toISOString();
  }
}

export function validateScheduleData(data: any): { isValid: boolean; errors: string[] } {
  const errors: string[] = [];
  
  if (!data.type || !reportTypes.find(t => t.value === data.type)) {
    errors.push('Invalid report type');
  }
  
  if (!data.recipients || !Array.isArray(data.recipients) || data.recipients.length === 0) {
    errors.push('At least one recipient is required');
  }
  
  if (data.recipients) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    data.recipients.forEach((email: string, index: number) => {
      if (!emailRegex.test(email)) {
        errors.push(`Invalid email format at position ${index + 1}: ${email}`);
      }
    });
  }
  
  if (!data.frequency || !frequencyOptions.find(f => f.value === data.frequency)) {
    errors.push('Invalid frequency');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}
